<template>
  <v-container
    id="axis-list"
  >
    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="axis"
          item-key="name"
          class="elevation-1"
          :loading="loading"
          loading-text="Carregando ..."
        >
          <template v-slot:item.acoes="{ item }">

            <v-row>
              <v-col
                cols="1"
              >
                <app-modal-insert-axis
                  :object="item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  @on-save="loadAxis"
                >
                  <template v-slot:title>
                    Edição de Eixo
                  </template>
                </app-modal-insert-axis>
              </v-col>

              <v-col
                cols="1"
              >
                <!-- <app-modal-delete-axis
                  :payload="item"
                  @on-save="loadAxis"
                >
                  <template v-slot:title>
                    Deletar Eixo
                  </template>
                </app-modal-delete-axis> -->
              </v-col>
            </v-row>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { axisAPI } from '@/modules/axis'
import AppModalInsertAxis from './ModalInsert'
// import AppModalDeleteAxis from './ModalDelete'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppAxisList',
  components: {
    AppModalInsertAxis
    // AppModalDeleteAxis
  },
  data () {
    return {
      headers: [
        {
          text: '#',
          value: 'eixoId',
          sortable: false
        },
        {
          text: 'Nome',
          align: 'left',
          value: 'nome'
        },
        {
          text: 'Descricao',
          value: 'descricao'
        },
        {
          text: 'Projeto',
          value: 'projeto.nome'
        },
        {
          text: 'Ações',
          value: 'acoes',
          sortable: false
        }
      ],
      axis: [],
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: 'cidade'
        },
        {
          text: 'Gestão de Eixos',
          disabled: true,
          href: 'eixo'
        }
      ]
    }
  },
  mounted () {
    this.loadAxis()
  },
  computed: {
    ...mapGetters([
      'loading'
    ])
  },
  methods: {
    ...mapActions([
      'setLoading'
    ]),
    loadAxis () {
      this.setLoading(true)
      axisAPI.list()
        .then(resp => {
          this.axis = resp.data
          this.setLoading(false)
        })
        .catch(resp => {
          this.setLoading(false)
          this.$notification.error('Erro ao listar eixos')
        })
    }
  }
}
</script>

<style lang="scss">@import './style.scss';</style>
